'use strict';
import { Howl } from 'howler';

class BGMController1 extends Howl {
  constructor(path, html5) {
    super({
      src: [path],
      preload: true,
      html5: html5,
      sprite: {
        proc_chat03rere: [0, 16065.306122448981],
        proc_chat_top01_home_re2: [18000, 64052.244897959186],
      },
    });

    this.spriteKeys = ['proc_chat03rere', 'proc_chat_top01_home_re2'];
  }

  hasKey(key) {
    return this.spriteKeys.includes(key);
  }
}

export default BGMController1;
